import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/boost_mode.svg'

const BoostModeIcon: React.FC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 20 20'} component={Icon} {...props} fill="currentColor" />
export default BoostModeIcon
